<template>
  <v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans">
    <register-status></register-status>
    <v-layout row wrap>
      <v-flex offset-md1 md10>
        <v-layout row wrap mt-5>
          <v-flex xs12 sm6 md6>
            <featured></featured>
          </v-flex>
          <v-flex xs12 sm6 md6>
            <div class="pa-3">
              <v-layout row wrap pa-4 class="elevation-1">
                <v-flex xs12 class="box-title">
                  <strong>Minha conta</strong>
                </v-flex>
                <v-flex xs12>
                  <img :src="company.logo" alt="" style="max-width:100%;max-height:147px">
                </v-flex>
                <v-flex xs6 mt-2>
                  <strong>Nome da empresa</strong>
                </v-flex>
                <v-flex xs6 mt-2>
                  {{ company.tradingName }}
                </v-flex>
                <v-flex xs12 mb-2 mt-2>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs6>
                  <strong>Endereço</strong>
                </v-flex>
                <v-flex xs6>
                  {{ company.address }} - {{ company.addressNumber }} / {{ company.complement }}
                </v-flex>
                <v-flex xs12 mb-2 mt-2>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs6>
                  <strong>Seu contrato</strong>
                </v-flex>
                <v-flex xs6 class="plano-btn">
                  <div @click="planos">Plano básico</div>
                </v-flex>
                <v-flex xs12 mt-2>
                  <div class="link" @click="cadastro">
                    Editar dados
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <overview></overview>
            <!-- <div class="pa-3">
              <v-layout row wrap pa-3 class="elevation-1">
                <v-flex md12>
                  <star-rate value="1"></star-rate>
                  <strong>Negócios</strong>
                </v-flex>
                <v-flex md12>
                  <p>Divulgue um produto ou serviço para mais de 15.000 condomínios, acesse este recurso e conheça mais.</p>
                </v-flex>
              </v-layout>
            </div> -->
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import starRate from '@/components/StarRate'
import overview from './overview'
import featured from './featured'
import registerStatus from './RegisterStatus'
export default {
  name: 'PInicio',
  components: {
    'star-rate': starRate,
    'overview': overview,
    'featured': featured,
    'register-status': registerStatus
  },
  methods: {
    details (id) {
      this.$store.commit('toggleOrderDetailsModal', true)
    },
    planos () {
      this.$router.push('/Painel/Conta/Planos/')
    },
    apagaNotificacao (url) {
      this.$store.commit('deleteNotification', url)
    },
    cadastro () {
      this.$router.push('/Painel/Conta/Empresa/')
    }
  },
  computed: {
    company () {
      return this.$store.getters.company
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.visao-geral{

}
.visao-geral .icone{
  margin-top: 20px;
  cursor: pointer;
  text-align: center;
  color: #717171;
}
.icone img {
  height: 50px;
  width: 51px;
}
.destaques-tabs .tabs__bar {
  background-color: transparent!important;
}
.destaques-tabs .tabs__item{
  border-bottom: 2px solid #ececf3;
}
.destaques-tabs .tabs__item.tabs__item--active{
 color: #ea2c31!important;
}
.destaques-tabs .tabs__slider{
  background: #ea2c31!important;
}
.notificacao-red{
  background-color: #ea2c31;
  border-color: #ea2c31;
}
.cadastro-red{
  color: #ea565d!important;
}
.plano-btn div{
  background: #0264c7;
  padding: 5px 10px;
  float: left;
  color: #fff;
  cursor: pointer;
}
.input-search {
  border: 1px solid #d9d9d9;
  border-radius: 15px;
  padding: 8px;
  position: relative;
}
.desaparece{
  display: none;
}
.input-search input{
  position: absolute;
  outline: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  padding-left: 37px;
  font-size: 22px;
  color: #5a5a5a;
}
.nothing-new{
  font-size: 18px;
  text-align: center;
  color: #777777;
}
.loading-box{
  height: 2px;
  position: absolute;
  bottom: 0px;
  left: 0;
  margin: 0;
}
.box-card{
  position: relative;
}
.box-title{
  margin-bottom: 10px;
  color: #6d7884;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// index.vue?10b3056e